import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const getStates = companyId => {
  return {
    Result: true,
    Reason: '',
    data: [
      {
        id: '1',
        name: 'placed',
        namealias: 'Placed',
        labelname: 'Place',
        nextstatusid: '2,4',
        approveroleid: '4,7',
        emailtemplate: '',
        sendmailtoroles: '4,7',
        filterroleid: '1,2,3,4,6,8',
      },
      {
        id: '2',
        name: 'accepted',
        namealias: 'Accepted',
        labelname: 'Accept',
        nextstatusid: '3,4',
        approveroleid: '3,6,1',
        emailtemplate: '',
        sendmailtoroles: '3,6,1',
        filterroleid: '1,2,3,4,6,8',
      },
      {
        id: '3',
        name: 'fulfilled',
        namealias: 'Fulfilled',
        labelname: 'Fulfill And Create Invoice',
        nextstatusid: '0',
        approveroleid: '',
        emailtemplate: '',
        sendmailtoroles: '',
        filterroleid: '1,2,3,4,6,8',
      },
      {
        id: '4',
        name: 'rejected',
        namealias: 'Rejected',
        labelname: 'Reject',
        nextstatusid: '0',
        approveroleid: '',
        emailtemplate: '',
        sendmailtoroles: '',
        filterroleid: '1,2,3,4,6,8',
      },
    ],
  };
};

const getOrders = (globalOutletId, companyId, pageInput) => {
  if (companyId === '470041') {
    return [
      {
        id: '2',
        warehouseId: '1',
        amountToShow: '193.50000',
        totalItems: 1,
        forDate: '2019-06-18 04:02:58',
        orderStatusAlias: 'Placed',
        statusId: '1',
        orderDetail: [
          {
            id: '3',
            skunitId: '47',
            unitPrice: '64.50000',
            quantity: '3.00',
            amount: '193.50000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '2',
            skuName: 'Good Knight Silver Refill 60N, Rs.72/-',
            unitsPerCase: '1',
          },
        ],
        paymentDetail: [],
      },
      {
        id: '1',
        warehouseId: '2',
        amountToShow: '375.63000',
        totalItems: 2,
        forDate: '2019-06-18 04:02:02',
        orderStatusAlias: 'Placed',
        statusId: '1',
        orderDetail: [
          {
            id: '1',
            skunitId: '15',
            unitPrice: '17.90000',
            quantity: '15.00',
            amount: '268.50000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '1',
            skuName: 'Cadbury Gems 27.8gm, Rs.20/-',
            unitsPerCase: '1',
          },
          {
            id: '2',
            skunitId: '18',
            unitPrice: '35.71000',
            quantity: '3.00',
            amount: '107.13000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '1',
            skuName: 'Cadbury Dairy Milk Fruit &amp; Nut 38gm, Rs.40/-',
            unitsPerCase: '1',
          },
        ],
        paymentDetail: [],
      },
    ];
  } else if (companyId === '470042') {
    return [
      {
        id: '3',
        warehouseId: '5',
        amountToShow: '475.59000',
        totalItems: 2,
        forDate: '2019-06-18 04:05:36',
        orderStatusAlias: 'Placed',
        statusId: '1',
        orderDetail: [
          {
            id: '5',
            skunitId: '59',
            unitPrice: '104.74000',
            quantity: '3.00',
            amount: '314.22000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '3',
            skuName: 'Surf Excel Matic Top Load powder 500gm, Rs 112/- ',
            unitsPerCase: '1',
          },
          {
            id: '6',
            skunitId: '3094',
            unitPrice: '53.79000',
            quantity: '3.00',
            amount: '161.37000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '3',
            skuName: 'Surf Excel Easy Wash 500gm, Rs.60/-',
            unitsPerCase: '1',
          },
        ],
      },
      {
        id: '2',
        warehouseId: '5',
        amountToShow: '154.34950',
        totalItems: 2,
        forDate: '2019-06-18 04:05:06',
        orderStatusAlias: 'Placed',
        statusId: '1',
        orderDetail: [
          {
            id: '3',
            skunitId: '239',
            unitPrice: '9.09130',
            quantity: '15.00',
            amount: '136.36950',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '2',
            skuName: 'Bourbon 60gm, Rs 10/-',
            unitsPerCase: '1',
          },
          {
            id: '4',
            skunitId: '243',
            unitPrice: '8.99000',
            quantity: '2.00',
            amount: '17.98000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '2',
            skuName: 'Good Day Butter 83gm(26%Extra), Rs.10/-',
            unitsPerCase: '1',
          },
        ],
      },
      {
        id: '1',
        warehouseId: '5',
        amountToShow: '276.18000',
        forDate: '2019-06-18 04:04:17',
        orderStatusAlias: 'Placed',
        statusId: '1',
        orderDetail: [
          {
            id: '1',
            skunitId: '28',
            unitPrice: '21.20000',
            quantity: '2.00',
            amount: '42.40000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '1',
            skuName: 'Surf Excel Easy Wash 200gm, Rs.23/-',
            unitsPerCase: '1',
          },
          {
            id: '2',
            skunitId: '57',
            unitPrice: '116.89000',
            quantity: '2.00',
            amount: '233.78000',
            discount: '0.00000',
            schemeDiscount: '0.00000',
            isFree: false,
            orderId: '1',
            skuName: 'Surf Excel Matic Front Load powder 500gm, Rs 125/-',
            unitsPerCase: '1',
          },
        ],
      },
    ];
  }
};

const rejectOrder = (globalOutletId, companyId, orderId, payload) => {
  return JSON.stringify({
    Result: true,
    Reason: 'Order rejected',
    orderstate_id: '7',
    orderstate_name: null,
  });
};

const mocks = {
  Query: {
    orderStates: (_, { companyId }) => getStates(companyId),
    orders: (_, { globalOutletId, companyId, pageInput }) =>
      getOrders(globalOutletId, companyId, pageInput),
  },
  Mutation: {
    rejectOrder: (_, { globalOutletId, companyId, orderId, payload }) =>
      rejectOrder(globalOutletId, companyId, orderId, payload),
  },
};
export { resolvers, typeResolvers, mocks };
